module.exports = __webpack_public_path__ + "b571123b1557fc334e8e6b956f843910.svg";